var _rect, _rect2, _path, _rect3, _path2, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridLightActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 62,
    viewBox: "0 0 104 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 54,
    transform: "translate(4 4)",
    fill: "#5C617C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 40,
    height: 40,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 31.5C32.6406 31.5 34 30.1641 34 28.5C34 26.8594 32.6406 25.5 31 25.5C29.3359 25.5 28 26.8594 28 28.5C28 30.1641 29.3359 31.5 31 31.5ZM33.0859 32.25H32.6875C32.1719 32.5078 31.6094 32.625 31 32.625C30.3906 32.625 29.8047 32.5078 29.2891 32.25H28.8906C27.1562 32.25 25.75 33.6797 25.75 35.4141V36.375C25.75 37.0078 26.2422 37.5 26.875 37.5H35.125C35.7344 37.5 36.25 37.0078 36.25 36.375V35.4141C36.25 33.6797 34.8203 32.25 33.0859 32.25Z",
    fill: "#6E7391"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 11,
    width: 40,
    height: 40,
    rx: 2,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73 31.5C74.6406 31.5 76 30.1641 76 28.5C76 26.8594 74.6406 25.5 73 25.5C71.3359 25.5 70 26.8594 70 28.5C70 30.1641 71.3359 31.5 73 31.5ZM75.0859 32.25H74.6875C74.1719 32.5078 73.6094 32.625 73 32.625C72.3906 32.625 71.8047 32.5078 71.2891 32.25H70.8906C69.1562 32.25 67.75 33.6797 67.75 35.4141V36.375C67.75 37.0078 68.2422 37.5 68.875 37.5H77.125C77.7344 37.5 78.25 37.0078 78.25 36.375V35.4141C78.25 33.6797 76.8203 32.25 75.0859 32.25Z",
    fill: "#6E7391"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 103,
    height: 61,
    stroke: "#5C617C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridLightActive);
export default __webpack_public_path__ + "static/media/grid-light-active.61f57cbe0.svg";
export { ForwardRef as ReactComponent };